import { render, staticRenderFns } from "./ManageSmsAction.vue?vue&type=template&id=10d01ba6&scoped=true&"
import script from "./ManageSmsAction.vue?vue&type=script&lang=js&"
export * from "./ManageSmsAction.vue?vue&type=script&lang=js&"
import style0 from "./ManageSmsAction.vue?vue&type=style&index=0&id=10d01ba6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d01ba6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d01ba6')) {
      api.createRecord('10d01ba6', component.options)
    } else {
      api.reload('10d01ba6', component.options)
    }
    module.hot.accept("./ManageSmsAction.vue?vue&type=template&id=10d01ba6&scoped=true&", function () {
      api.rerender('10d01ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/Sms/ManageSmsAction.vue"
export default component.exports